import React from 'react';

// Recursively localize the string children of a JSX tree (tour/FAQ content
// authored as React elements, where wrapping every literal in lt() would be
// unmaintainable). Only string children are mapped; props, hrefs, and
// non-element values pass through untouched. Identity when lt is identity
// (non-US), so AU trees render the exact same strings.
export const localizeNode = (node, lt) => {
  if (typeof node === 'string') return lt(node);
  if (Array.isArray(node)) return node.map((child) => localizeNode(child, lt));
  if (React.isValidElement(node)) {
    const children = node.props?.children;
    if (children === undefined) return node;
    return React.cloneElement(node, {}, localizeNode(children, lt));
  }
  return node;
};

export const localizeAccordionItems = (items, lt) =>
  items.map((item) => ({
    ...item,
    title: typeof item.title === 'string' ? lt(item.title) : localizeNode(item.title, lt),
    content: localizeNode(item.content, lt),
  }));
